export const websiteUrl = import.meta.env.VITE_WEBSITE_URL
  ? import.meta.env.VITE_WEBSITE_URL
  : "https://dev-sponsor.konfhub.com";
export const webCliendId = import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID
  ? import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID
  : "1cum79568pe0u434ek1d5kin9a";
export const s3Url = `https://konfhub-image-files-${
  import.meta.env.ENV_NAME || "dev"
}.s3.${
  import.meta.env.VITE_AWS_PROJECT_REGION || "ap-southeast-1"
}.amazonaws.com`;
export const recaptchaId =
  import.meta.env.VITE_RECAPTCHA_ID ||
  "6Lc8YC8iAAAAACu7i43HCm1Zi_nh8rcBbwOiQ2zw";